import React from 'react';
import { Comment } from '../../../interfaces/ticket/Comment';
import AvatarImage from '../../ui/Avatar/AvatarImage';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperclip } from '@fortawesome/free-solid-svg-icons';
import DOMPurify from 'dompurify';
import '../IssuesPage/IssuesPage.css';

interface CommentCardProps {
    comment: Comment;
}

const CommentCard: React.FC<CommentCardProps> = ({ comment }) => {
    const sanitizedMessage = DOMPurify.sanitize(comment.message, {
        ADD_ATTR: ['data-id', 'data-value', 'data-denotation-char', 'data-index', 'class'],
        ADD_TAGS: ['span'],
    });

    console.log('Comment', comment)
    return (
        <div className="comment-card">
            <div className="comment-author-avatar">
                <AvatarImage size='xs' userId={comment.authorId} />
            </div>
            <div className="comment-content">
                <div className="comment-header">
                    <span className="comment-author-name">{comment.authorDisplayName}</span>
                    <span className="comment-date">{new Date(comment.createdAt).toLocaleString()}</span>
                </div>
                <div className="comment-body">
                    <div 
                        className="comment-message" 
                        dangerouslySetInnerHTML={{ __html: sanitizedMessage }} 
                    />
                    {comment.attachments && comment.attachments.length > 0 && (
                        <ul className="attachment-list">
                            {comment.attachments.map(attachment => (
                                <li key={attachment.id}>
                                    <a href={attachment.url} target="_blank" rel="noopener noreferrer" className="attachment-link">
                                        <FontAwesomeIcon icon={faPaperclip} /> {attachment.fileName}
                                    </a>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
};

export default CommentCard;
